<p-dialog [visible]="show()" (visibleChange)="show.set($event)" [modal]="true" [draggable]="true"
  [resizable]="false" [closable]="true" [dismissableMask]="false" header="Send a Message"
  styleClass="menu-dialog" [style]="{ width: '640px' }" [breakpoints]="{ '640px': '95vw' }">
  <div class="send-form">

    <div class="field">
      <label>Template <span class="req">*</span></label>
      <p-select [ngModel]="key()" (ngModelChange)="onKeyChange($event)" [options]="keyOptions()"
        [editable]="true" [filter]="true" placeholder="Pick a template key" appendTo="body" />
    </div>

    <div class="field">
      <label>Channels</label>
      <div class="channel-row">
        <p-checkbox [binary]="true" [ngModel]="chWhatsapp()" (ngModelChange)="chWhatsapp.set($event)"
          inputId="ch-wa" />
        <label for="ch-wa" class="ch-label"><i class="pi pi-whatsapp"></i> WhatsApp</label>
        <p-checkbox [binary]="true" [ngModel]="chSms()" (ngModelChange)="chSms.set($event)"
          inputId="ch-sms" />
        <label for="ch-sms" class="ch-label"><i class="pi pi-comment"></i> SMS</label>
        <p-checkbox [binary]="true" [ngModel]="chEmail()" (ngModelChange)="chEmail.set($event)"
          inputId="ch-em" />
        <label for="ch-em" class="ch-label"><i class="pi pi-envelope"></i> Email</label>
      </div>
      @if (!anyChannel()) {
        <small class="hint-muted">
          None ticked — the server resolves the channels from the message type via the messaging rules.
        </small>
      }
    </div>

    <div class="grid-2">
      @if (needsMobile()) {
        <div class="field">
          <label>Mobile</label>
          <input pInputText type="text" [ngModel]="mobile()" (ngModelChange)="mobile.set($event)"
            placeholder="98XXXXXXXX" autocomplete="off">
        </div>
      }
      @if (needsEmail()) {
        <div class="field">
          <label>Email</label>
          <input pInputText type="text" [ngModel]="email()" (ngModelChange)="email.set($event)"
            placeholder="someone@example.com" autocomplete="off">
        </div>
      }
    </div>

    <div class="grid-2">
      <div class="field">
        <label>Partner <span class="hint-inline">optional scope</span></label>
        <p-select [ngModel]="partnerId()" (ngModelChange)="partnerId.set($event)"
          [options]="partnerOptions()" optionLabel="label" optionValue="value" [filter]="true"
          filterBy="label" [showClear]="true" placeholder="Global" appendTo="body" />
      </div>
      <div class="field">
        <label>Client <span class="hint-inline">optional scope</span></label>
        <p-select [ngModel]="clientId()" (ngModelChange)="clientId.set($event)"
          [options]="clientOptions()" optionLabel="label" optionValue="value" [filter]="true"
          filterBy="label" [showClear]="true" placeholder="Global" appendTo="body" />
      </div>
    </div>

    @if (placeholderNames().length) {
      <div class="field">
        <label>Placeholders <span class="hint-inline">Company is filled automatically</span></label>
        <div class="ph-grid">
          @for (name of placeholderNames(); track name) {
            <div class="ph-item">
              <span class="ph-name">{{ name }}</span>
              <input pInputText type="text" [ngModel]="values()[name] || ''"
                (ngModelChange)="setValue(name, $event)" autocomplete="off">
            </div>
          }
        </div>
      </div>
    }

    <div class="grid-2">
      <div class="field">
        <label>Message type</label>
        <input pInputText type="text" [ngModel]="messageType()" (ngModelChange)="messageType.set($event)"
          placeholder="OTP / COI / PAYMENT_LINK...">
        <small class="hint-muted">Classifies the outbox row; resolves channels when none are ticked.</small>
      </div>
      <div class="field">
        <label>Schedule <span class="hint-inline">empty = send now</span></label>
        <p-datepicker [ngModel]="schedule()" (ngModelChange)="schedule.set($event)" [showTime]="true"
          hourFormat="12" [showClear]="true" dateFormat="dd M yy" appendTo="body"
          placeholder="Send immediately" />
      </div>
    </div>

    <div class="field">
      <label>Attachment</label>
      <div class="attach-row">
        <input #f type="file" class="hidden-input" [accept]="acceptTypes"
          (change)="onPick(f.files); f.value = ''">
        <p-button [label]="file() ? 'Replace' : 'Attach file'" icon="pi pi-paperclip" size="small"
          [outlined]="true" [disabled]="uploading()" (onClick)="f.click()" />
        @if (uploading()) {
          <span class="status"><i class="pi pi-spin pi-spinner"></i> Uploading…</span>
        } @else if (file(); as up) {
          <span class="file-chip"><i class="pi pi-file"></i> {{ up.fileName }}</span>
          <p-button icon="pi pi-times" severity="danger" [text]="true" size="small"
            pTooltip="Remove attachment" (onClick)="clearFile()" />
        } @else {
          <span class="hint-muted">Optional — WhatsApp sends it as media, email attaches it, SMS ignores it.</span>
        }
      </div>
      @if (file()) {
        <small class="hint-muted">
          WhatsApp delivers an attachment only through an approved template whose header type
          matches the file (image / document) — pair the template accordingly.
        </small>
      }
    </div>

    <div class="modal-actions">
      <p-button label="Cancel" [outlined]="true" (onClick)="close()" [disabled]="sending()" />
      <p-button label="Queue message" icon="pi pi-send" (onClick)="send()"
        [loading]="sending()" [disabled]="uploading()" />
    </div>
  </div>
</p-dialog>
